module.exports = __webpack_public_path__ + "static/media/saskatchewan.87d1a894.png";